import { put, call, take, fork } from 'redux-saga/effects'
import { getCourseAnalyticsReportService } from '../../api/course'
import { GET_COURSE_ANALYTICS_REPORT } from '../../reducers/course/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* getCourseAnalyticsReportFlow(payload) {
  try {
    const { courseId, callback } = payload

    const response = yield call(getCourseAnalyticsReportService, courseId)

    yield put(operationSuccess())
    callback(response.data)
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* getCourseAnalyticsReportWatcher() {
  while (true) {
    const action = yield take(GET_COURSE_ANALYTICS_REPORT)
    const { payload } = action

    yield fork(generalSaga, getCourseAnalyticsReportFlow, payload)
  }
}
